import { useI18n } from "../../i18n/I18nProvider.js";

const socialDestinations = [
    {
        href: "https://t.me/dino_college",
        label: "Telegram",
        icon: "✈️"
    },
    {
        href: "https://www.instagram.com/dino_college",
        label: "Instagram",
        icon: "📸"
    }
] as const;

function SocialLinks() {
    const { t } = useI18n();

    return (
        <nav
            aria-label={t("footer.socialLabel")}
            className="flex flex-wrap items-center gap-2"
        >
            {socialDestinations.map(destination => (
                <a
                    className="inline-flex min-h-11 items-center gap-1.5 rounded-control px-2.5 py-2 text-sm font-semibold text-dino-800 no-underline transition hover:bg-dino-100 hover:text-dino-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dino-600"
                    href={destination.href}
                    key={destination.label}
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <span aria-hidden="true">{destination.icon}</span>
                    {destination.label}
                    <span aria-hidden="true">↗</span>
                </a>
            ))}
        </nav>
    );
}

export { SocialLinks, socialDestinations };
